module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/199/assets/images/cba5dfffeff72f0804c9a112c811517b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_minimise_dark.svg
// module id = xEM8
// module chunks = 1